import clsx from "clsx";
import { formatDateShortIntl2 } from "../../../../helpers/FormatDate";
import { CSSProperties } from "react";


const PLACEHOLDER_ROWS = 5

type Props = {
    columns: { 
        key: string; 
        label: string; 
        width: string;
        getValue?: (u: any) => React.ReactNode;
        labelStyles?: CSSProperties;

    }[];
    data: any[];
    loading: boolean;
    onSelect?: (u: any) => void;
    placeholder_rows?: number;
}

export const ProfileMemberGrid = ({ columns, data, loading, onSelect, placeholder_rows }: Props) => {
      const renderCells = (
        items: any[],
        isLoading: boolean,
        getValue: (u: any) => React.ReactNode,
        keyPrefix: string,
        skeletonWidth: string = '70%',
        onSelect?: (u: any) => void,
        isDate:boolean = false,
        valueStyle?: CSSProperties,
      ) => {
        if (isLoading) {
          return Array.from({length: placeholder_rows ?? PLACEHOLDER_ROWS}).map((_, index) => (
            <div
              key={`${keyPrefix}-${index}`}
              className={`table__cell ${index === 0 ? 'table__cell--bold' : ''}`}
            >
              <span className='skeleton skeleton--text' style={{width: skeletonWidth}} />
            </div>
          ))
        }
        return items.map((u, index) => (
          <div key={`${keyPrefix}-${index}`}
            className={`cursor-pointer table__cell`} style={valueStyle}
            onClick={() => onSelect?.(u)}  
          >
            {isDate ? formatDateShortIntl2(getValue(u) as string) : getValue(u)}
          </div>
        ))
      }



    return (
        <div className='table'>
            {columns.map((h, i) => (
                <div key={i} className={clsx('table__column', `table__column--${h.key}`)}>
                    <div className='table__header'>{h.label}</div>
                    {renderCells(
                        data,
                        loading, 
                        h.getValue ? ((u: any) => h.getValue!(u)): ((u: any) => u[h.key]), 
                        h.key,
                        h.width,
                        onSelect
                    )}
                </div>
            ))}
        </div>
    )
}